import { Routes, Route, useLocation } from 'react-router-dom';
import Home from '../pages/Home';
import Work from '../pages/Work';
import NotFound from '../pages/NotFound';
import { useLayoutEffect } from 'react';

const Main = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [pathname]);

  return (
    <main className="container max-w-screen-md mx-auto px-4 py-8">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
  );
};

export default Main;
